function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4441 5.68734C15.4441 2.40767 13.0724 -0.260542 9.82049 -0.380981H9.6074H0V15.6283H3.43717V11.7557H7.93051L10.7747 15.6283H14.74L11.6549 11.4036C13.9988 10.5605 15.4441 8.31849 15.4441 5.68734ZM11.9791 5.74293V5.81704V5.82631C11.905 7.64217 10.6358 9.08745 8.80138 9.08745H3.43717V3.35266V3.18589V2.5559H8.80138C10.6358 2.5559 11.905 3.74177 11.9791 5.55763V5.5669V5.64102V5.6966V5.74293ZM83.1684 -0.288327H87.1151L87.1429 -0.251269L94.5268 15.619L90.9506 15.6283L89.6165 12.9415H80.6762L79.3421 15.6653L75.7381 15.6561L83.1684 -0.288327ZM85.1417 2.82458L81.7694 10.3382H88.5326L85.1417 2.82458ZM103.893 12.8302H109.73C110.036 12.8302 110.305 13.0063 110.425 13.2935L111.259 15.3409C111.314 15.4799 111.212 15.6281 111.064 15.6281H100.493V-0.112424H103.893V12.8302ZM63.1105 12.7931C65.4544 12.7931 67.3537 10.8938 67.3537 8.54988C67.3537 8.4665 67.3444 0.0171712 67.3352 0.0171712H70.6056V8.54988C70.5778 12.6726 67.2332 15.8875 63.1012 15.8875C58.9692 15.8875 55.6247 12.6726 55.5969 8.54988V0.0171712H58.8673V8.54988C58.8673 10.8938 60.7665 12.7931 63.1105 12.7931ZM34.3902 3.08376H39.8841V15.4983H43.2194V3.08376H48.704V0.0171712H34.3902V3.08376ZM23.5878 -0.186517H26.9879V15.3595H23.5878V-0.186517Z",
  fill: "#18303A"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M139.774 3.80327L136.136 0.151442C135.783 -0.201522 135.24 -0.201522 134.887 0.151442L129.28 5.79888L123.66 0.151442C123.307 -0.201522 122.764 -0.201522 122.411 0.151442L118.786 3.80327C118.433 4.15623 118.433 4.69926 118.786 5.05222L129.28 15.6276L139.774 5.0658C140.127 4.69926 140.127 4.16981 139.774 3.80327Z",
  fill: "#18303A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.28 5.7984L124.392 10.7128L129.28 15.6271L134.153 10.7128L129.28 5.7984Z",
  fill: "#18303A"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.5308,
  height: 15.7477,
  fill: "white",
  transform: "translate(118.514 -0.120544)"
})));

function SvgRitualLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 16,
    viewBox: "0 0 141 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRitualLogo);
export default __webpack_public_path__ + "static/media/Ritual-Logo.2dc1cb10.svg";
export { ForwardRef as ReactComponent };